"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useListKeyboardNav = useListKeyboardNav;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _findNextItem3 = require("./findNextItem");
var _activateStrategies = require("./activateStrategies");
/**
* List-like component keyboard navigation utility.
*
* By default it use item index, when "idAttribute" is specified, it will use the related element attribute
* instead.
* */
function useListKeyboardNav(_ref) {
  var containerRef = _ref.containerRef,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus,
    circularMove = _ref.circularMove,
    activated = _ref.activated,
    setActivated = _ref.setActivated,
    activateItemOption = _ref.activateItem,
    idAttribute = _ref.idAttribute,
    itemFilter = _ref.itemFilter,
    _ref$backwardCodes = _ref.backwardCodes,
    backwardCodes = _ref$backwardCodes === void 0 ? ['ArrowUp'] : _ref$backwardCodes,
    _ref$forwardCodes = _ref.forwardCodes,
    forwardCodes = _ref$forwardCodes === void 0 ? ['ArrowDown'] : _ref$forwardCodes;
  var isMovingForward = _react["default"].useCallback(function (code) {
    return forwardCodes.includes(code);
  }, [forwardCodes]);
  var isMovingCursor = _react["default"].useCallback(function (code) {
    return forwardCodes.concat(backwardCodes).includes(code);
  }, [backwardCodes, forwardCodes]);
  var isEligibleEvent = _react["default"].useCallback(function (event) {
    var eventTarget = event.target;
    if (eventTarget === containerRef.current) {
      return true;
    }
    if (itemFilter && !itemFilter(eventTarget)) {
      return false;
    }
    if (idAttribute && !eventTarget.hasAttribute(idAttribute)) {
      return false;
    }
    return true;
  }, [containerRef, itemFilter, idAttribute]);
  var activateItem = _react["default"].useMemo(function () {
    return _activateStrategies.composeStrategy.apply(void 0, (0, _toConsumableArray2["default"])([autoFocus && _activateStrategies.scrollNextItemIntoView, autoFocus && _activateStrategies.focusNextItem, _activateStrategies.activateNextItem, autoFocus && _activateStrategies.adjustMetasForInitialFocus].filter(function (s) {
      return !!s;
    })));
  }, [autoFocus]);
  _react["default"].useEffect(function () {
    var container = containerRef.current;
    var listener = function listener(event) {
      if (isEligibleEvent(event) && isMovingCursor(event.code)) {
        event.preventDefault();
        var direction = isMovingForward(event.code) ? 'forward' : 'backward';
        var _analyseList = (0, _findNextItem3.analyseList)({
            current: activated,
            container: container,
            idAttribute: idAttribute,
            itemFilter: itemFilter
          }),
          candidates = _analyseList.candidates,
          currentElement = _analyseList.currentElement;
        var _findNextItem = (0, _findNextItem3.findNextItem)({
            circularMove: circularMove,
            container: container,
            current: activated,
            direction: direction,
            idAttribute: idAttribute,
            itemFilter: itemFilter
          }),
          _findNextItem2 = (0, _slicedToArray2["default"])(_findNextItem, 2),
          nextItem = _findNextItem2[0],
          nextElement = _findNextItem2[1];
        (activateItemOption !== null && activateItemOption !== void 0 ? activateItemOption : activateItem)({
          container: container,
          currentItem: activated,
          currentElement: currentElement,
          nextItem: nextItem,
          nextElement: nextElement,
          direction: direction,
          eligibleItems: candidates,
          setActivated: setActivated
        });
      }
    };
    container === null || container === void 0 || container.addEventListener('keydown', listener);
    return function () {
      container === null || container === void 0 || container.removeEventListener('keydown', listener);
    };
  }, [activateItem, activateItemOption, circularMove, containerRef, idAttribute, itemFilter, activated, isEligibleEvent, isMovingForward, isMovingCursor, setActivated]);
}